import { Component } from '@angular/core';
import { AbstractFormConstructorComponent } from '../form-constructor-abstract.component';

@Component({
  selector: 'app-form-constructor',
  templateUrl: './form-constructor.component.html',
  styleUrls: ['./form-constructor.component.scss'],
})
export class FormConstructorComponent extends AbstractFormConstructorComponent {
  public prepareSubmitData(): void {
    this.getFormValues(this.childForm.form);
  }
}
